import { render, staticRenderFns } from "./tagTypeFilterElement.vue?vue&type=template&id=79ad3c4c"
import script from "./tagTypeFilterElement.vue?vue&type=script&lang=js"
export * from "./tagTypeFilterElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports